import React from "react";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { WhitelabelLockComponent } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/modules/WhitelabelLockComponent/WhitelabelLockComponent";
import { useWhitelabelLock } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/useWhitelabelLock";
import { useWhitelabel } from "features/Account/modules/Whitelabel/utils/useWhitelabel";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import FeatureCard from "features/FeatureActivation/modules/FeatureCard";
import { useFeatureAccessibility } from "features/Account/utils/useFeatureAccessibility";
import { FEATURE_KEYS } from "features/Account/Account.constants";
import { RESOURCE_KEYS } from "utils/OrgPermissions";

export const WhitelabelFeatureCard = () => {
  const { handleWhitelabelPurchase, whiteLabelDetails } = useWhitelabel({
    fetchFeatureStatus: false,
  });
  const { isFeatureAccessible } = useFeatureAccessibility();
  const isWhitelabelActive = isFeatureAccessible({
    featureKey: FEATURE_KEYS.whitelabel,
  });
  const { showWhitelabelUnlockModal, toggleWhitelabelUnlockModal } =
    useWhitelabelLock();

  return (
    <>
      <FeatureCard
        featureName={
          RESOURCE_KEYS.TABS.MANAGE_OFFERING.VERIFICATION_AT_CHECKOUT
        }
        desktopImage={getS3AssetCDNUrl(
          "assets/images/ct_upfront/verification_at_checkout.png"
        )}
        mobileImage={getS3AssetCDNUrl(
          "assets/images/ct_upfront/verification_at_checkout.png"
        )}
        ctaText={`Upgrade Plan`}
        // textConClasses={style.lockPreviewContainer}
        descriptionClasses="!tw-text-[#7F5400] !tw-font-[500]"
        customLockIcon={
          <LockOutlinedIcon
            className="tw-text-[#7F5400] tw-mb-4"
            fontSize="large"
          />
        }
        onClick={toggleWhitelabelUnlockModal}
      />
      <WhitelabelLockComponent
        hideLabel
        hideIcon
        modalDescription={{
          heading: "Edit Verification at Checkout via White-labelling",
          subHeading:
            "With white-labelling you can expect the following changes",
          pointers: [
            "Edit Terms & Condition statement",
            "Add Terms & Condition",
            "Can enable Aadhaar Verification",
            "Can enable KRA Workflow",
          ],
        }}
        isAccessible={isWhitelabelActive}
        handleWhitelabelPurchase={handleWhitelabelPurchase}
        whiteLabelDetails={whiteLabelDetails}
        showWhitelabelUnlockModal={showWhitelabelUnlockModal}
        toggleWhitelabelUnlockModal={toggleWhitelabelUnlockModal}
      />
    </>
  );
};
